module.exports = __webpack_public_path__ + "img/logoXpectra.7b679d4f.png";